export default "__VITE_ASSET__Ca6pC0Lq__"